import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import React from "react";

import { ConnectionStateChipProps } from "../ConnectionStateChip";

export const ConnectionStateButton: React.FC<ConnectionStateChipProps> = ({
  state,
  stateConfig,
  onClick,
  size = "small",
  sx,
  disabled = false
}) => {
  const config = stateConfig[state];

  if (!config) {
    console.warn(`ConnectionStateButton: No configuration found for state "${state}"`);
    return null;
  }

  return (
    <Tooltip title={config.label}>
      <span>
        <IconButton
          data-testid="toggle-live-update"
          value={config.value}
          onClick={onClick}
          color={config.color}
          size={size}
          disabled={disabled}
          sx={{
            ...sx,
            ...(config.overrideColor && {
              "& .MuiSvgIcon-root": {
                fill: `${config.overrideColor}!important`
              }
            })
          }}
          role="menuitem">
          {config.icon}
        </IconButton>
      </span>
    </Tooltip>
  );
};
